import { useState, useEffect } from 'react';

// subscribe to every change, even if there was no transition!
const useSubscribeRouter = (router) => {
  const [router_state, setRouterState] = useState(() => ({previousRoute: null, route: router.getState()}))

  useEffect(() => {
    return router.subscribe(({ route, previousRoute }) => {
      setRouterState({ route, previousRoute })
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return router_state;
}


export default useSubscribeRouter;

